import React, { useState, useEffect } from "react";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  ContentSideBySideCustomInv,
  Hero,
  Gallery,
  SpacerV,
  Stats,
} from "../components/Hero";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TextField from "@mui/material/TextField";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../actions/auth";
import { alertMessage } from "../actions/auth";
import Lottie from "react-lottie";
import {
  Collage,
  Features,
  OurProcess,
  Tailor,
  YouWillGet,
  Trust,
} from "../components/Sections";
import { UpInView } from "../components/PositionFadeInView";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";

export default function ContactUs() {
  useEffect(() => {}, []);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const timelineDelays = [0, 600, 1200, 1800, 2400];
  const timelineDelays2 = [100, 200, 300, 400];
  const timelineDelays3 = [700, 800, 900];

  const timelineDelays4 = [1300, 1400, 1500];

  function onSubmit(e) {
    e.preventDefault();
    var body = {};
    body["name"] = name;
    body["email"] = email;
    body["phone_number"] = phoneNumber;
    body["subject"] = subject;
    body["description"] = description;

    axios
      .post(API_URL + "add_contact", JSON.stringify(body))
      .then((res) => {
        setName("");
        setEmail("");
        setPhoneNumber("");
        setDescription("");
        setSubject("");

        dispatch(
          alertMessage(
            "SUCCESS",
            "SUCCESS",
            "Your request has been submitted. Our team will get back to you."
          )
        );
      })
      .catch((err) => {});
  }

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div style={{ marginTop: "6vh" }} />
        <div
          style={{
            padding: state.auth.isMobile ? "15px" : "100px",
            maxWidth: state.auth.isTablet ? "97.5vw" : "100vw",
          }}
          className="anigrad"
        >
          <Grid
            container
            spacing={
              state.auth.isTablet ? (state.auth.isLandscape ? 47.5 : 30) : 15
            }
            style={{
              width: "100%",
              paddingTop: state.auth.isMobile ? "100px" : 0,
            }}
          >
            <Grid
              item
              md={7}
              xs={12}
              sm={12}
              style={{
                maxWidth: state.auth.isMobile ? "80vw" : "100vw",
                height: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                height: "100%",
              }}
            >
              <UpInView delay={timelineDelays[2]}>
                <div
                  style={{
                    fontSize: "32px",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  USA
                </div>
              </UpInView>
              <UpInView delay={timelineDelays4[0]}>
                <div
                  style={{
                    borderTop: "1px solid white",
                    marginTop: "25px",
                    paddingTop: "15px",
                    fontSize: "2.2vh",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <LocationOnIcon
                    style={{
                      color: "white",
                      fontSize: "22px",
                      marginRight: "15px",
                    }}
                  />{" "}
                  301 NJ-17, Rutherford, NJ 07070, United States{" "}
                </div>
              </UpInView>
              <br />
              <UpInView delay={timelineDelays4[1]}>
                <a
                  href="tel:+12014562171"
                  style={{
                    cursor: "pointer",
                    fontSize: "2.2vh",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                  }}
                >
                  <PhoneInTalkIcon
                    style={{
                      color: "white",
                      fontSize: "22px",
                      marginRight: "15px",
                    }}
                  />{" "}
                  +1 201 456 2171
                </a>
              </UpInView>
              <br />
              <UpInView delay={timelineDelays3[2]}>
                <a
                  href="mailto:letstalk@richesmediadigital.com"
                  style={{
                    cursor: "pointer",
                    fontSize: "2.2vh",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                  }}
                >
                  <EmailIcon
                    style={{
                      color: "white",
                      fontSize: "28px",
                      marginRight: "15px",
                    }}
                  />{" "}
                  letstalk@richesmediadigital.com
                </a>
              </UpInView>
              <br />
              <br />
              <br />
              <UpInView delay={timelineDelays[1]}>
                <div
                  style={{
                    fontSize: "32px",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  India
                </div>
              </UpInView>
              <UpInView delay={timelineDelays3[0]}>
                <div
                  style={{
                    borderTop: "1px solid white",
                    marginTop: "25px",
                    paddingTop: "15px",
                    fontSize: "2.2vh",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <LocationOnIcon
                    style={{
                      color: "white",
                      fontSize: "22px",
                      marginRight: "15px",
                    }}
                  />{" "}
                  3, A V Square, Block No.7, BEML Layout, Mysuru, Karnataka
                  570023
                </div>
              </UpInView>
              <br />
              <UpInView delay={timelineDelays3[1]}>
                <a
                  href="tel:+918214240111"
                  style={{
                    cursor: "pointer",
                    fontSize: "1.8vh",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                  }}
                >
                  <PhoneInTalkIcon
                    style={{
                      color: "white",
                      fontSize: "22px",
                      marginRight: "15px",
                    }}
                  />{" "}
                  +91 8214240111
                </a>
              </UpInView>
              <br />
              <UpInView delay={timelineDelays3[2]}>
                <a
                  href="mailto:letstalk@richesmediadigital.com"
                  style={{
                    cursor: "pointer",
                    fontSize: "2.2vh",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                  }}
                >
                  <EmailIcon
                    style={{
                      color: "white",
                      fontSize: "22px",
                      marginRight: "15px",
                    }}
                  />{" "}
                  letstalk@richesmediadigital.com
                </a>
              </UpInView>
              <br />
            </Grid>
            <Grid
              item
              md={5}
              xs={12}
              sm={12}
              style={{
                maxWidth: state.auth.isMobile ? "80vw" : "100vw",
                height: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                minHeight: "50vh",
                paddingLeft: state.auth.isMobile ? "75vw" : "5vw",
              }}
            >
              <form
                className="anigrad-inv"
                style={{
                  backdropFilter: "blur(5px)",
                  padding: "25px",
                  borderRadius: "5px",
                }}
                onSubmit={onSubmit}
              >
                <div
                  style={{
                    width: state.auth.isMobile ? "80vw" : "100",
                    fontSize: state.auth.isMobile ? "30px" : "30px",
                    fontWeight: "600",
                    lineHeight: "55px",
                    color: "black",
                    textAlign: "center",
                    zIndex: 999,
                  }}
                >
                  Contact Us
                </div>
                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: 600,
                        opacity: 1,
                      },
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="name"
                  autoComplete="name"
                  autoFocus
                  placeholder="Name *"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    dispatch({
                      type: "NAV_COLOR",
                      payload: { navColor: "#444", navOpacity: 1 },
                    });
                  }}
                />
                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: 600,
                        opacity: 1,
                      },
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  placeholder="E-mail *"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    dispatch({
                      type: "NAV_COLOR",
                      payload: { navColor: "#444", navOpacity: 1 },
                    });
                  }}
                />
                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: 600,
                        opacity: 1,
                      },
                  }}
                  type="number"
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="phonenumber"
                  autoComplete="phonenumber"
                  autoFocus
                  placeholder="Phone number *"
                  value={phoneNumber}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value);
                    dispatch({
                      type: "NAV_COLOR",
                      payload: { navColor: "#444", navOpacity: 1 },
                    });
                  }}
                />
                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    height: "400",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: 600,
                        opacity: 1,
                      },
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="description"
                  autoComplete="description"
                  multiline
                  rows={4}
                  autoFocus
                  placeholder="Description of your enquiry *"
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    dispatch({
                      type: "NAV_COLOR",
                      payload: { navColor: "#444", navOpacity: 1 },
                    });
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "2.2vh",
                  }}
                >
                  <Button
                    style={{
                      width: "100%",
                      height: "6vh",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryButtonColor
                          : themeStyle.primaryButtonColor,
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryButtonTextColor
                          : themeStyle.primaryButtonTextColor,
                    }}
                    type="submit"
                    variant="contained"
                  >
                    <span
                      style={{
                        fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                        fontWeight: 600,
                      }}
                    >
                      SUBMIT REQUEST
                    </span>
                  </Button>
                </div>
              </form>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            padding: state.auth.isMobile ? "15px" : "100px",
            backgroundColor: "#111",
          }}
        >
          <div
            style={{
              width: state.auth.isMobile
                ? state.auth.isTablet
                  ? "100vw"
                  : "80vw"
                : "100vw",
              fontSize: state.auth.isMobile ? "30px" : "60px",
              fontWeight: "600",
              lineHeight: "55px",
              color: "white",
              textAlign: "center",
              zIndex: 999,
            }}
          >
            How to Locate Us
          </div>
          <br />
          <br />
          <br />
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3019.4682539426676!2d-74.1010857!3d40.8176774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f9a233dfa1c3%3A0x4b1d4bbdd0165a1c!2sRiches%20Media%20Digital!5e0!3m2!1sen!2sin!4v1754034378621!5m2!1sen!2sin"
            style={{ width: "100%", height: "75vh", borderRadius: "25px" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div style={{ display: state.auth.isMobile ? "none" : "block" }}>
          <Trust invert />
        </div>
        <OurProcess
          invert
          step1={"Reach Out to Understand Your Needs"}
          step1description={
            "We begin by listening to you. Share your goals, questions, or challenges, and our team will guide you to the right solutions. Whether you're looking for development support, design services, or strategic consulting, we're here to help."
          }
          step2={"Collaborate to Find Tailored Solutions"}
          step2description={
            "Our experts will work closely with you to identify the best approaches and craft innovative solutions tailored to your unique needs. We value open communication and collaborative problem-solving to ensure the best outcomes."
          }
          step3={"Stay Informed with Transparent Communication"}
          step3description={
            "We believe in keeping you in the loop. From the initial inquiry to project updates and beyond, our team ensures transparent and timely communication so that you always know where things stand."
          }
          step4={"Build Long-Term Relationships with Dedicated Support"}
          step4description={
            "Our commitment doesn't end after the initial interaction. We strive to build long-term relationships by providing ongoing support and ensuring your satisfaction at every step. Connect with us and experience a partnership that grows with your success."
          }
        />

        <YouWillGet
          title1={"Personalized Assistance"}
          title2={"Quick Responses"}
          title3={"Expert Guidance"}
          title4={"Ongoing Support"}
          title5={"Seamless Communication"}
        />
        <div style={{ display: state.auth.isMobile ? "none" : "block" }}></div>
        <Stats />
        <div style={{ height: "100px" }} />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
